import * as z from "zod";
import { mutator } from "./mutator";

export const revokeAllSessionsSchema = z.object({});

export const revokeAllSessions = mutator({
  schema: revokeAllSessionsSchema,
  resolve: {},
  permissions: [
    { permission: "tenant:sso_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async () => {},
});
